import {MinusOutlined, PlusOutlined} from '@ant-design/icons';
import {Form, Input} from 'antd';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';

const Styled = styled.div`

    /* add padding to icon so the clickable area encloses the whole div */
    --icon-padding-x: 11px;
    --icon-padding-y: 8px;

    .large {
        --icon-padding-x: 11px;
        --icon-padding-y: 12px;
    }

    .small {
        --icon-padding-x: 6px;
        --icon-padding-y: 3.25px;
    }

    .disabled {
        color: rgba(0, 0, 0, 25%);
        text-shadow: none;
        cursor: not-allowed;
        background: #f5f5f5;
        border-color: #d9d9d9;
        box-shadow: none;
    }

    .input__quantity {
        width: ${props => props.width};

        .ant-input-wrapper.ant-input-group {
            .ant-input {
                text-align: center;    
            }
        }

        /* + and - icon */
        .ant-input-group-addon {
            padding: 0;

            &:hover,&:active {
                color: var(--neutralDark);
                cursor: pointer;
            }

            &:active {
                box-shadow: 0 0 5px var(--neutral);
            }

            transition: color 0.2s, box-shadow 0.1s ease-out;

            .icon__change-qty {
                padding: var(--icon-padding-y) var(--icon-padding-x);
            }
        }
    }
`;

/**
 *
 * Props:
 * - width (int/String) : width of Input area. Optional, defaults to '100%'.
 * - size (String) : 'small', 'default', 'large'. Optional, defaults to 'default'.
 * - formRef (instance). Required.
 */
class QuantityInputProduct extends Component {
    static defaultProps = {
        size: 'default',
    };

    roundOffAsInt = aVar => parseInt(Math.round(aVar), 10) || 1;

    onMinusQty = () => {
        const {
            formRef,
        } = this.props;

        const {qty} = formRef.current.getFieldsValue();
        formRef.current.setFieldsValue({
            // Avoid NaN when user clears field or enter invalid
            qty: qty ? this.roundOffAsInt(Math.max(qty - 1, 1)) : 1,
        });
    };

    onPlusQty = () => {
        const {
            formRef,
        } = this.props;

        const {qty} = formRef.current.getFieldsValue();
        formRef.current.setFieldsValue({
            qty: qty ? this.roundOffAsInt(qty + 1) : 1, // Avoid NaN when user clears field or enter invalid
        });
    };

    onBlurQty = e => {
        const {
            formRef,
        } = this.props;

        const qty = this.roundOffAsInt(e.target.value);

        // set Form UI
        formRef.current.setFieldsValue({
            qty,
        });
    };

    render() {
        const {
            width,
            size,
            disabled,
            ...restProps
        } = this.props;

        return (
            <Styled width={width} {...restProps}>
                <Form.Item
                    name="qty"
                    rules={[
                        { required: true, message: 'Please enter at least 1' },
                        { type: 'number', message: 'Please enter a number' },
                    ]}
                    noStyle
                >
                    <Input
                        className="input__quantity"
                        size={size}
                        addonBefore={<MinusOutlined
                            className={`icon__change-qty ${size} ${disabled ? 'disabled' : ''}`}
                            onClick={this.onMinusQty}
                        />}
                        addonAfter={<PlusOutlined
                            className={`icon__change-qty ${size} ${disabled ? 'disabled' : ''}`}
                            onClick={this.onPlusQty}
                        />}
                        onBlur={this.onBlurQty}
                        disabled={disabled}
                    // value={qty}
                    />
                </Form.Item>
            </Styled>
        );
    }
}

export default connect(() => ({

}),
{

})(QuantityInputProduct);
